import React from 'react';
import { StyledMockupGrid } from './StyledMockupGrid';

const MockupGrid = ({noPadding, iframeUrl, zoom}) => {

  return (
    <React.Fragment>
      {
       
          <StyledMockupGrid className={ noPadding ? "no--padding" : ""}>
            <div className="browser--wrap">
              <div className="browser--head">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div className="browser--body">
                <div className="browser--side">
                  <div className="side--lines">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div className="side--squares">
                    <div className="square--wrap">
                      <div className="square"></div>
                      <div className="line"></div>
                    </div>
                    <div className="square--wrap">
                      <div className="square"></div>
                      <div className="line"></div>
                    </div>
                  </div>
                </div>
                <div className="browser--grid">
                  <div className="browser-cell">
                    {
                      !iframeUrl &&
                      <img src={require("../../assets/carousel-prods.png")} />
                    }
                    {
                      iframeUrl &&
                      <div className="size--handler">
                        <img className="size--placeholder" src={require("../../assets/mockup-size.png")} />
                        <iframe frameBorder="0" width="100%" src={`https://sketchfab.com/models/${iframeUrl}/embed?autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_in=${zoom}`} />
                      </div>
                    }
                    <div className="browser--cell-lines">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <div className="browser-cell hide-mobile"></div>
                  <div className="browser-cell hide-mobile"></div>
                  <div className="browser-cell hide-mobile"></div>
                </div>
              </div>
            </div>
          </StyledMockupGrid>
          
      }
    </React.Fragment>
  );
};

export default MockupGrid;
